
namespace TabAurous.Stock {

    @Serenity.Decorators.registerClass()
    export class StockSelectGrid extends _Ext.GridBase<StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return StockItemRow.idProperty; }
        protected getLocalTextPrefix() { return StockItemRow.localTextPrefix; }
        protected getService() { return Stock.StockItemService.baseUrl; }

        constructor(container: JQuery, options) {
            super(container, options);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            (this.view.params as TransactionRequest).DepartmentId = options.GridFilters.DepartmentId;
            return this;
        }
        get selectedItems(): StockItemRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            return true;

        }

    }
}